import CryptoJS from 'crypto-js'
import { environment } from '../../environment'

const secretKey = environment.secretKey

export function encrypt(data: string) {
  if (!secretKey) {
    return data
  }
  return CryptoJS.AES.encrypt(data, secretKey, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

export function decrypt(ciphertext: string) {
  if (!secretKey) {
    return ciphertext
  }
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return bytes.toString(CryptoJS.enc.Utf8)
}

export function hashMD5(data: string) {
  return CryptoJS.MD5(data).toString()
}
